//@ts-check
import { action, makeAutoObservable } from 'mobx';
import StatsRequests from "Utils/Requests/StatsRequests";
import FiltersStore from 'Stores/Stats/FiltersStore';
import { ShowAlert } from "Utils/CommonFunctions";
import Helper from "Utils/Helper";

class StatsStore {
    //initDataLoading;
    dataLoading;
    /** @type {StatWeb} */
    data;
    renderStore;
    graphsWidth;

    constructor() {
        makeAutoObservable(this);

        //this.initDataLoading = true;
        this.dataLoading = true;
        this.data = null;
        this.renderStore = {
            filterDateFrom: {},
            filterDateTo: {}
        };
        this.graphsWidth = 1000;
    }

    GetData() {
        this.dataLoading = true;

        StatsRequests.GetData(FiltersStore.filters).then(action(values => {
            this.data = values;

            this.dataLoading = false;
        }));
    }

    ExportData() {
        this.dataLoading = true;

        StatsRequests.ExportData(FiltersStore.filters)
            .finally(action(() => this.dataLoading = false));
    }

    /**
     * @param {number} sizeBytes
     */
    GetFileSizeMb(sizeBytes) {
        let sizeMb = sizeBytes / 1024 / 1024;
        return sizeMb < 1 ? "< 1" : Math.round(sizeMb);
    }

    /**
     * @param {React.ChangeEvent<HTMLInputElement>} inputFileSelectEvent
     */
    ImportData(inputFileSelectEvent) {
        if (!inputFileSelectEvent.target.files ||
            inputFileSelectEvent.target.files.length == 0)
            return;

        let file = inputFileSelectEvent.target.files[0];
        file.text().then(text => {
            let data = Helper.JsonParse(text);
            if (data?.sectionUsersCount == null) {
                ShowAlert('error', `Ошибка загрузки файла "${file.name}".`);
            }
            else {
                this.data = data;
            }
        });
    }
}

export default new StatsStore();